import styled from "styled-components";
import { theme } from "../theme";

export const StyledLogin = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	padding: 8.5rem 2rem;
	background-color: #3a4149;
	flex-grow: 1;
	align-items: center;
	justify-content: center;
	border-radius: 0.5rem;
	.inner {
		background-color: ${theme.color.background};
		box-shadow: 0 0.2rem 0.3rem rgba(0, 0, 0, 0.16);
		padding: 5rem 2rem 9rem;
		max-width: 90rem;
		width: 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		/* flex-grow: 1; */
	}
`;
